import { Controller } from "@hotwired/stimulus";

/**
 * Tells the courier quote what terms to price under
 * when the merchant changes their mind (CAL-499).
 *
 * A cash trip and a prepaid trip to the same door are
 * two different quotes, and the builder's payment
 * answer is the only thing on the page that says which
 * one this is. `courier-quote` cannot read it for
 * itself: it looks for a `payment_choice` radio, and
 * the staff form derives that server-side and renders
 * none.
 *
 * The value each answer carries is decided in Ruby, in
 * `PaymentCardComponent::COURIER_PAYMENT_METHODS`, and
 * arrives here as an action param. It deliberately does
 * NOT follow `payment_choice`: cash and "already paid"
 * are both `later` orders, and pricing an already-paid
 * trip as cash sends a courier to collect money the
 * merchant already has. See the comment on that
 * constant.
 *
 * Writing the data value rather than calling a method
 * on the other controller: `courier-quote` re-quotes
 * from its own `paymentMethodValueChanged`, so the
 * change and the re-quote cannot fall out of step, and
 * a page with no courier on it needs no special case
 * here beyond the outlet being absent.
 */
export default class extends Controller {
  static outlets = ["courier-quote"];

  update(event) {
    if (!this.hasCourierQuoteOutlet) return;

    const method = event.params.method;
    if (!method) return;

    this.courierQuoteOutletElement.dataset
      .courierQuotePaymentMethodValue = method;
  }
}
